"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CaptchaGenerator_1 = require("./CaptchaGenerator");
exports.default = CaptchaGenerator_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/CaptchaGenerator/index.js
// module id = 1105
// module chunks = 8